import React from 'react';
import * as S from './styles';
import { XCircle } from '@olxbr/ds-icons';
const shouldShowErrorMessage = (disabled, state, stateMessage) => !disabled && state === 'error' && stateMessage !== undefined && stateMessage !== '';
const shouldShowCaption = (caption) => caption !== undefined && caption !== '';
export const InferiorContent = ({ caption, disabled, errorId, state, stateMessage, }) => {
    if (shouldShowErrorMessage(disabled, state, stateMessage))
        return (React.createElement(React.Fragment, null,
            React.createElement(S.FeedbackErrorMessage, { id: errorId, 
                /* Utilizado provisoriamente até correção do componente Text aceitar as props do componente renderizado, neste exemplo uma label
                @ts-ignore-line */
                role: "alert", "aria-describedby": "contentError" },
                React.createElement(S.Icon, null,
                    React.createElement(XCircle, { size: "16px" })),
                React.createElement(S.TextError, { id: "contentError" }, stateMessage))));
    if (shouldShowCaption(caption))
        return (React.createElement(S.Caption, { display: "block", marginTop: "--spacing-1" }, caption));
    return null;
};
